import React from 'react'

import { BoxDetails } from 'routes/Checkout/Components/BoxDetails/BoxDetails'
import { BoxDetailsHighlight } from 'routes/Checkout/Components/BoxDetailsHighlight'
import { Summary } from 'routes/Checkout/Components/Summary'
import { useIsCheckoutHighlightOfferEnabled } from 'routes/Checkout/hooks/useIsCheckoutHighlightOfferEnabled'

type OrderSummaryAndBoxDetailsProps = {
  isCreatingPreviewOrder: boolean
  isGoustoOnDemandEnabled: boolean
}

/**
 * Container for "Order Summary" and "Box details" containers showed during checkout.
 */
export const OrderSummaryAndBoxDetails = ({
  isCreatingPreviewOrder,
  isGoustoOnDemandEnabled,
}: OrderSummaryAndBoxDetailsProps) => {
  const isCheckoutHighlightExperimentEnabled = useIsCheckoutHighlightOfferEnabled()

  if (isCheckoutHighlightExperimentEnabled) {
    return <BoxDetailsHighlight isLoading={isCreatingPreviewOrder} />
  }

  return (
    <>
      {/** TS and Eslint errors are suppressed as component was moved to TypeScript, but children components are not yet written in TS yet. */}
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <Summary isLoading={isCreatingPreviewOrder} showPromoCode={!isGoustoOnDemandEnabled} />
      <BoxDetails />
    </>
  )
}
